import { AfterViewInit, Directive, inject } from '@angular/core';

import { InterviewResultCardComponent } from './interview-list/interview-result-card/interview-result-card.component';
import { QuickEvaluationCacheService } from './quick-evaluation-cache.service';

@Directive({
  selector: '[cachedQuickEvaluationFormOpener]',
})
export class CachedQuickEvaluationFormOpenerDirective implements AfterViewInit {
  private readonly host = inject(InterviewResultCardComponent);

  private readonly cacheService = inject(QuickEvaluationCacheService);

  public ngAfterViewInit(): void {
    const cachedFormState = this.cacheService.getValue(this.host.result.id);

    if (!cachedFormState) {
      return;
    }

    this.host.openQuickEvaluationForm();
  }
}
